/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Divider from '@material-ui/core/Divider';
import { gridWithGap } from './summary.helper';

const useStyles = makeStyles(() => ({
  container: {
    ...gridWithGap,
  },
  span6: {
    ...gridWithGap,
    gridColumn: 'span 6',
  },
}));

/**
 * Responsive Summary component with cards for the main submission components that gets used
 * in the Submission form and for the sending confirmation screen.
 * @returns {JSX.Element}
 * @constructor
 */
export default function SmallSummary({ receiptCard, orderedBodyCards, dialog }) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <div className={classes.span6}>{receiptCard}</div>
        <Divider className={classes.span6} />
        <div className={classes.span6}>{orderedBodyCards}</div>
      </div>
      {dialog}
    </>
  );
}
